module.exports = __webpack_public_path__ + "img/logo-vuejs.f738cd15.png";